<template>
    <div
        :class="{ [`part-${rowData.products_id}`]: true, disabled: hasDisableRule }"
        :id="`part-${rowData.products_id}`"
        class="product-data p-x"
        style="position: relative;"
    >
        <div class="product-info-container">
            <div class="product-info-content">
                <div class="product-image">
                    <img :src="rowData.image" alt="">
                </div>
                <div class="about-product">
                    <h5 class="text-white">
                        {{ rowData.name }}
                        <template v-if="partName == 'ram'">
                            <small>(max speed)</small>
                            <span
                                v-if="rowData.products_id == partsRam.products_id"
                                v-html="computeRamCapacity(partsRam.capacity, rowData.slots, partsRam.quantity)"
                            />
                        </template>
                    </h5>
                    <p class="part-description">
                        {{ truncate(rowData.description) }}
                        <template v-if="rowData.products_id == partsRam.products_id">
                            <a @click="openDetailsModal(partsRam)" href="#">MORE INFO</a>
                        </template>
                        <template v-else-if="partsSsd.some(ssd => ssd.products_id == rowData.products_id)">
                            <a @click="openDetailsModal(partsSsd.find(ssd => ssd.products_id == rowData.products_id))" href="#">MORE INFO</a>
                        </template>
                        <template v-else>
                            <a @click="openDetailsModal(rowData)" href="#">MORE INFO</a>
                        </template>
                    </p>
                </div>
            </div>
            <div class="cant-select">
                <row-buttons
                    v-if="!hasDisableRule && !tabDisabled"
                    :buttons-type="buttonsType"
                    :part-info="rowData"
                    :part-name="partName"
                    :can-deselect="canDeselect"
                    :row-structure="rowStructure"
                />
                <disabled-button v-else :buttons-type="buttonsType" />
            </div>
            <disabled-message v-if="hasDisableRule" :message="hasDisableRule.msg" />
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { computeRamCapacity } from "@u/store-helpers";
import DisabledButton from "./components/disabled-button";
import DisabledMessage from "./components/disabled-message";
import RowButtons from "./components/row-buttons";
export default {
    name: "TabRow",
    components: {
        DisabledButton,
        DisabledMessage,
        RowButtons
    },
    props: {
        partName: String,
        rowData: Object,
        rowStructure: Object,
        buttonsType: String,
        canDeselect: Boolean,
        tabDisabled: {
            type: Boolean,
            required: true
        },
        tabSlug: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapState({
            disableRules: state => state.Step4.disableRules,
            partsRam: state => state.Step4.activeBuild && state.Step4.activeBuild.ram || {},
            partsSsd: state => state.Step4.activeBuild && state.Step4.activeBuild.ssd || {}
        }),
        hasDisableRule() {
            return this.disableRules.find(rule => rule.ruleType == "disable" && rule.partToChange == this.tabSlug && rule.products.products_id == this.rowData.products_id);
        }
    },
    methods: {
        ...mapActions(["changePartDetails"]),
        computeRamCapacity,
        truncate(text, length = 120, etc = "…", breakWords = false, remaining = false) {
            let truncatedText = "";

            if (!length) {
                return truncatedText;
            }

            if (etc == "...") {
                etc = "…";
            }

            if (text.length > length) {
                if (!breakWords) {
                    truncatedText = text.substr(0, length).replace(/\s+?(\S+)?$/, "") + etc;
                } else {
                    truncatedText = text.substr(0, length).replace(/\s*$/, "") + etc;
                }
            } else {
                truncatedText = text;
            }

            if (remaining) {
                truncatedText = [truncatedText, text.substr(truncatedText.length - etc.length)];
            }

            return truncatedText;
        },
        async openDetailsModal(part) {
            const partDetails = {
                show: true,
                id: part.products_id,
                variantId: part.id,
                partName: this.partName
            };

            if (this.partName == "ram") {
                partDetails.name = this.rowData.name,
                partDetails.capacity = this.computeRamCapacity(part.capacity, this.rowData.slots, part.quantity);
            }

            await this.changePartDetails(partDetails);
            $('#parts-details-modal').modal();
        }
    }
}
</script>

<style lang="scss" scoped>
.product-info-container {
    display: flex;
    align-items: center;
    width: 100%;
}

.part-description {
    position: relative;
    z-index: 1;
    color: #fff;
    margin: 0 0 10px;
}
</style>
